import { render, staticRenderFns } from "./AssignSupport.vue?vue&type=template&id=37818b57"
import script from "./AssignSupport.vue?vue&type=script&lang=js"
export * from "./AssignSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports